// Product Grid Column
window.theme = window.theme || {};

theme.collectionProduct = (function () {
  function productGrid() {
    const productColBtnWrapper = document.querySelector(
      ".product__grid_column_buttons"
    );
    const gridColumnWrapper = document.querySelector("#ProductGridContainer");

    if (!productColBtnWrapper || !gridColumnWrapper) return;

    const storage = window.selinzaSafeStorage;
    const gridColumnButtons = productColBtnWrapper.querySelectorAll(
      ".gird__column_icon"
    );
    const validGridClasses = [
      "grid-col-1",
      "grid-col-2",
      "grid-col-3",
      "grid-col-4",
      "grid-col-5",
    ];

    let gridClassName = storage?.getItem("gridColumn");
    if (!validGridClasses.includes(gridClassName)) gridClassName = "";

    function activateGridClass(nextGridClass) {
      if (!validGridClasses.includes(nextGridClass)) return;

      gridColumnWrapper.classList.remove(...validGridClasses);
      gridColumnWrapper.classList.add(nextGridClass);
      storage?.setItem("gridColumn", nextGridClass);
      gridClassName = nextGridClass;

      gridColumnButtons.forEach((button) => {
        const buttonGridClass = button.classList.contains("product_col_two")
          ? "grid-col-2"
          : button.classList.contains("product_col_three")
          ? "grid-col-3"
          : button.classList.contains("product_col_four")
          ? "grid-col-4"
          : "";

        button.classList.toggle("active", buttonGridClass === nextGridClass);
      });
    }

    if (gridClassName) activateGridClass(gridClassName);

    gridColumnButtons.forEach((button) => {
      button.addEventListener("click", () => {
        if (button.classList.contains("product_col_two")) {
          activateGridClass("grid-col-2");
        } else if (button.classList.contains("product_col_three")) {
          activateGridClass("grid-col-3");
        } else if (button.classList.contains("product_col_four")) {
          activateGridClass("grid-col-4");
        }
      });
    });
  }

  return productGrid;
})();
